import React, { useContext, useEffect } from 'react'
import { useCurrentRefinements } from 'react-instantsearch-hooks-web';
import sortBy from 'lodash/sortBy';
import appContext from '../../Context/appContext';
import { sortFilter } from '../../constants/search';
import CustomSlider from '../CustomSlider';
import isMobile from '../../helpers/isMobile';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedPriceSort } from '../../redux/slices/searchSlice';

const sortCurentRefinments = items => {
  const sortedlist = sortBy(items, function (element) {
    const rank = {
      deviceType: 4,
      brands: 2,
      full_shop_categories: 1,
      strain: 3
    };

    return rank[element.label];
  });
  return sortedlist;
};


const SelectedFilterList = ({ filterType, className, setListLoading, setFilterApplied }) => {

  // const {
  //   // state: {
  //   //   search: { selectedPriceSort }
  //   // },
  //   dispatch
  // } = useContext(appContext);

  const selectedPriceSort = useSelector(state => state.search.selectedPriceSort)

  const dispatchRedux = useDispatch()

  const { items } = useCurrentRefinements({
    includedAttributes: ['strain', 'full_shop_categories', 'brands', 'deviceType'],
    transformItems: sortCurentRefinments
  });

  const selectedPriceSortLabel = sortFilter?.find(item => item.id === selectedPriceSort);

  useEffect(() => {
    if (items.length || selectedPriceSort) {
      setFilterApplied(true);
    }
    else {
      setFilterApplied(false);
    }
  }, [items, selectedPriceSort])


  const scrollToFilter = () => {
    const header = document.getElementsByClassName('bento-header')[0];
    let element = null;
    let headerOffset = 0;

    if (isMobile()) {
      // Scroll for mobile view
      const deliveryTabs = document.getElementById("delivery-tabs-box")

      if (deliveryTabs?.getBoundingClientRect().top - 55 - 20 > header?.clientHeight) { // 55px is taken by category section, 20px is buffer
        if (deliveryTabs?.getBoundingClientRect().top - 55 - 20 - 37 > header?.clientHeight) return //39px is the label header height
      }

      element = document.getElementsByClassName('filter-product-page')[0];
      headerOffset = 200;

    } else {
      // Scroll for desktop view
      let header = document.getElementsByClassName('bento-header')[0]
      let filter = document.getElementsByClassName("desktop-filter-container")[0]
      if (filter?.getBoundingClientRect().top > header?.clientHeight) {
        if (filter?.getBoundingClientRect().top - 37 - 20 > header?.clientHeight) return // 37px is advert header height & 20px is buffer
      };

      element = document.getElementById('list-top');
      headerOffset = (header?.clientHeight + filter?.clientHeight) || 150;
    }

    const elementPosition = element?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
    });
  };


  return (
    <div className="container p-0" id="selected-filters-box">
      <>{items && <CustomSlider className={` selected-filters ${className} `}>
        {
          selectedPriceSort ?
            <div className={`${filterType} afl-container `}>
              <div className={`chip ${selectedPriceSortLabel?.label}-chips`} key={selectedPriceSortLabel?.label}>
                <>
                  {selectedPriceSortLabel?.label}
                  <button className="btn btn-sm s-close-btn">
                    <i className="icon icon-close" id='sort' onClick={() => {
                      window.scrollTo(0, 0);
                      setListLoading(true);
                      // dispatch({ type: 'setSelectedPriceSort', payload: '' });
                      dispatchRedux(setSelectedPriceSort(''))
                      scrollToFilter();
                      setTimeout(() => setListLoading(false), 500);
                    }} />
                  </button>
                </>
              </div>
            </div>
            : null
        }


        {items.map(item =>
          <div className={`${filterType} afl-container `} key={item?.attribute}> {
            item?.refinements?.map(curr => (
              <div className={`chip ${curr.label}-chips`} key={curr.label}>
                <>
                  {curr.label}
                  <button className="btn btn-sm s-close-btn">
                    <i className="icon icon-close" id={item.id} onClick={() => {
                      window.scrollTo(0, 0);
                      setListLoading(true);
                      item.refine(curr);
                      scrollToFilter();
                      setTimeout(() => setListLoading(false), 500);
                    }} />
                  </button>
                </>
              </div>
            ))
          }
          </div>
        )}
      </CustomSlider>}</>
    </div>
  );
}

export default SelectedFilterList